import React, { createContext, useContext } from 'react';
import { useMemoOne as useMemo } from 'use-memo-one';
import { EnvironmentContext } from '../environment';
export var MetricsContext = /*#__PURE__*/createContext({
  environment: undefined,
  product: '',
  page: ''
});
export var MetricsContextProvider = function MetricsContextProvider(_ref) {
  var value = _ref.value,
    children = _ref.children;
  var envFromContext = useContext(EnvironmentContext);
  var product = value.product,
    page = value.page,
    environment = value.environment;
  var memoedValue = useMemo(function () {
    return {
      environment: environment !== null && environment !== void 0 ? environment : envFromContext,
      product: product,
      page: page
    };
  }, [page, environment, envFromContext, product]);
  return /*#__PURE__*/React.createElement(MetricsContext.Provider, {
    value: memoedValue
  }, children);
};
export var useMetricsContext = function useMetricsContext() {
  return useContext(MetricsContext);
};